import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../axiosConfig';
import CreatePost from './CreatePost';
import ForumPost_Display from "./ForumPost_Display";
import './Master.css';

// State nickname mapping
const stateNicknames = {
  AL: "The Yellowhammer State",
  AK: "The Last Frontier",
  AZ: "The Grand Canyon State",
  AR: "The Natural State",
  CA: "The Golden State",
  CO: "The Centennial State",
  CT: "The Constitution State",
  DE: "The First State",
  FL: "The Sunshine State",
  GA: "The Peach State",
  HI: "The Aloha State",
  ID: "The Gem State",
  IL: "The Prairie State",
  IN: "The Hoosier State",
  IA: "The Hawkeye State",
  KS: "The Sunflower State",
  KY: "The Bluegrass State",
  LA: "The Pelican State",
  ME: "The Pine Tree State",
  MD: "The Old Line State",
  MA: "The Bay State",
  MI: "The Great Lakes State",
  MN: "The North Star State",
  MS: "The Magnolia State",
  MO: "The Show Me State",
  MT: "The Treasure State",
  NE: "The Cornhusker State",
  NV: "The Silver State",
  NH: "The Granite State",
  NJ: "The Garden State",
  NM: "Land of Enchantment",
  NY: "The Empire State",
  NC: "The Tar Heel State",
  ND: "The Peace Garden State",
  OH: "The Buckeye State",
  OK: "The Sooner State",
  OR: "The Beaver State",
  PA: "The Keystone State",
  RI: "The Ocean State",
  SC: "The Palmetto State",
  SD: "Mount Rushmore State",
  TN: "The Volunteer State",
  TX: "The Lone Star State",
  UT: "The Beehive State",
  VT: "The Green Mountain State",
  VA: "The Old Dominion",
  WA: "The Evergreen State",
  WV: "The Mountain State",
  WI: "The Badger State",
  WY: "The Equality State"
};

const StateForum_unique = () => {
  const { stateCode } = useParams(); // Extract the state code from the URL
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPosts();
  }, [stateCode]);

  const fetchPosts = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axiosInstance.get(`/messageboard/forums/${stateCode}/`);
      setPosts(response.data || []);
    } catch (error) {
      console.error('Error fetching posts for state:', error);
      setError('Failed to load forum posts. Please try again.');
      setPosts([]);
    } finally {
      setLoading(false);
    }
  };

  const handlePostCreated = (newPost) => {
    setPosts((prevPosts) => [newPost, ...prevPosts]);
  };

  // Get the state's tagline
  const stateTagline = stateNicknames[stateCode] || 'USA Forum'; // Default to "USA Forum" if the state code is not found

  if (loading) {
    return <div className="loading">Loading forum posts...</div>;
  }

  if (error) {
    return (
      <div className="error">
        <p>{error}</p>
        <button onClick={fetchPosts}>Try Again</button>
      </div>
    );
  }

  return (
    <>
      <h3>{stateTagline} Forum</h3> {/* Display the tagline */}
          <hr className="section-divider"/>

      {/* Create Post Component - OUTSIDE of any container */}
      <CreatePost
        apiEndpoint={`/messageboard/forums/${stateCode || "USA"}/`}
        onPostCreated={handlePostCreated}
      />


      {/* Forum Container */}
      <div className="forums-container">
        <div className="messageboard-content">
        <div className="general-forum-container">

          {posts.length === 0 ? (
            <div className="no-posts">
              <p>No posts yet. Be the first to create one!</p>
            </div>
          ) : (
            <div className="feed-container">
              {posts.map((post) => (
                <ForumPost_Display key={post.id} post={post}/>
              ))}
            </div>
          )}
        </div>
        </div>
      </div>
    </>
  );
};

export default StateForum_unique;